import React from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import { colorWithAlpha, darkenColor } from '../../utils/colorUtils';

interface TagBadgeProps {
  name: string;
  color: string;
  onRemove?: () => void;
  onClick?: () => void;
  size?: 'sm' | 'md' | 'lg';
  showRemove?: boolean;
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  name,
  color,
  onRemove,
  onClick,
  size = 'md',
  showRemove = false
}) => {
  const { isDark } = useTheme();
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const baseColor = isDark ? darkenColor(color, 0.25) : color;
  const backgroundColor = colorWithAlpha(baseColor, isDark ? 0.24 : 0.12);
  const borderColor = colorWithAlpha(baseColor, isDark ? 0.38 : 0.25);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium transition-colors ${
        onClick ? 'cursor-pointer hover:opacity-80' : ''
      } ${sizeClasses[size]}`}
      style={{
        backgroundColor,
        color: baseColor,
        border: `1px solid ${borderColor}`
      }}
      onClick={onClick}
    >
      {name}
      {showRemove && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="hover:bg-black/10 rounded-full p-0.5"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </span>
  );
};

